import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import {
  IImageDuplicatedIn,
  DuplicatedInType,
} from '@core/entities/ImageWarning'

export class ImageDuplicatedIn extends Entity<IImageDuplicatedIn> {
  type: DuplicatedInType

  id: number

  questionId: string

  summary: string

  templateName: string

  uuid: string

  templateVersionId: number

  mediaKey: string

  uploadedBy: string

  uploadOn: string

  public getTypeText(): string {
    return this.type.charAt(0).toUpperCase() + this.type.slice(1).toLowerCase()
  }

  public getTitle(): string {
    switch (this.type) {
      case 'PERMIT':
      case 'CHECKLIST':
        return `${this.getTypeText()} | ${this.templateName} (V${
          this.templateVersionId
        }) - ${this.uuid}`

      case 'TASK':
        return `${this.getTypeText()} | ${this.templateName} (V${
          this.templateVersionId
        })`
      default:
        return ''
    }
  }

  public static new(payload: unknown): ImageDuplicatedIn {
    const entity = plainToInstance(ImageDuplicatedIn, payload)

    return entity
  }
}
